import { Routes } from '@angular/router';
import { LayoutsComponent } from './layouts/layouts.component';
import { AppRoutesEnum, AppFullRoutes } from './@core/enum/appRoutes';
import { authRoutes } from './modules/authentication/authentication.routes';
import { RequireAuthGuard } from './@core/guards/require-auth.guard';
import { userRoutes } from './routes/app-user.routes';
import { HasAnyPermissionGuard } from './@core/guards/has-any-permission.guard';

export const routes: Routes = [
  {
    path: AppRoutesEnum.USER,
    component: LayoutsComponent,
    children: userRoutes,
      canActivate: [RequireAuthGuard, HasAnyPermissionGuard],
    // data: { roles: ['superadmin', 'provider', 'hmo', 'payer', 'insuree'] },
  },

  {
    path: AppRoutesEnum.AUTH,
    children: authRoutes,
  },
  {
    path: '',
    redirectTo: AppFullRoutes.FULL_USER_DASHBOARD,
    pathMatch: 'full',
  },

  {
    path: 'no-access',
    loadComponent: () =>
      import('./modules/no-access-page/no-access-page.component').then(
        (m) => m.NoAccessPageComponent,
      ),

    data: { type: 'no-access' },
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./modules/no-access-page/no-access-page.component').then(
        (m) => m.NoAccessPageComponent,
      ),
    data: { type: 'forbidden' },
  },

  //Note: Please don't create any route below this.
  {
    path: '**', // Wildcard for any non-matching routes
    loadChildren: () =>
      import('./modules/not-found-page/not-found-page.routes').then(
        (m) => m.notFoundPageRoutes,
      ),
  },
];
